module.exports = ".centered{\r\n    float: none;\r\n    margin: 0 auto;\r\n    }\r\n\r\n.c-btn-cta-secondary{\r\n    font-size: 11px;\r\n    height: 40px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/opc/auth/signin/signin.component.css
// module id = ./src/opc/auth/signin/signin.component.css
// module chunks = main